import AiButton, {
  AiButtonProps,
} from '@/components/Record/ActionButton/AiButton';
import WordReplaceButton, {
  WordReplaceButtonProps,
} from '@/components/Record/ActionButton/WordReplaceButton';
import React from 'react';
import styled from '@emotion/styled';
import SummaryMemoToggle from './SummaryMemoToggle';
import { Stack } from '@mui/material';

export type DocViewMode = 'content' | 'memo';

export type ContentHeaderProps = {
  aiButtonProps: AiButtonProps;
  wordReplaceButtonProps?: WordReplaceButtonProps;
  isOwner?: boolean;
  viewMode?: DocViewMode;
  onChangeViewMode?: (mode: DocViewMode) => void;
  contentDisabled?: boolean;
  /** 메모 탭 노출 여부 — 작성자는 항상, 비작성자(공유 문서)는 메모 내용이 있을 때만 */
  showMemoTab?: boolean;
  /** AI 정리 생성 중 — 'AI 정리' 토글 아이콘을 동영상(AI 아바타)으로 렌더 */
  isOrganizing?: boolean;
};

/**
 * 본문 상단 바 — [AI 정리 | 메모] 토글 + 우측 액션 버튼.
 *
 * 번역은 문서 전체 단일 토글로 통합되어 제목줄(Header)의 번역 버튼과
 * 상단 띠(TranslationStatusBar)가 담당한다. 여기에 있던 언어 드롭다운과
 * "AI 번역됨" 박스(원문 아래 번역본을 덧붙이던 방식)는 제거됐다.
 */
const ContentHeader = ({
  aiButtonProps,
  wordReplaceButtonProps,
  isOwner,
  viewMode = 'content',
  onChangeViewMode,
  contentDisabled,
  showMemoTab,
  isOrganizing,
}: ContentHeaderProps) => {
  return (
    <Stack>
      <StyledHeader>
        <SummaryMemoToggle
          viewMode={viewMode}
          onChangeViewMode={onChangeViewMode}
          showMemoTab={showMemoTab}
          contentDisabled={contentDisabled}
          isOrganizing={isOrganizing}
        />
        <Stack direction="row" gap="8px" alignItems="center">
          {isOwner && wordReplaceButtonProps && (
            <WordReplaceButton {...wordReplaceButtonProps} />
          )}
          <AiButton {...aiButtonProps} />
        </Stack>
      </StyledHeader>
    </Stack>
  );
};
export default ContentHeader;

const StyledHeader = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
`;
